import React, { Component } from "react"
import { NativeSelect, FormControl,InputLabel } from '@material-ui/core'
import { T } from 'Actions/translate';

class BasicSelect extends Component {

    // constructor(props) {
    //     super(props)

    // }

    componentWillMount() {

    }

    handleChange = title => event => {
        this.props.handleChange(title, event.target.value, event.currentTarget.selectedOptions[0].innerHTML);
    }

    render() {
        const { title, value, selectList,required } = this.props

        return (
	        <div className='basic-select'>
	        	<FormControl className='select-form'>
		            <InputLabel className='input_label'>
                {required ? <span className='form-required'>*</span> :null}
                {T(title)}
                </InputLabel>
		          	<NativeSelect
                  className='select-content'
		            	value={value}
                  onChange={this.handleChange(title)}
		          	>
                    {/* {
                        !value && value !== 0 ? <option>{T(title)}</option> : value
                    } */}
				        {selectList && selectList.map(item => {
		              return (
		                <option key={item.key} value={item.key}>{item.value}</option>
		              );
		            })}
		          	</NativeSelect>
		        </FormControl>
	        </div>
        )
    }
}

export default BasicSelect
